import { API_URL } from "../../../constants";
import { OrgAdmin, OrgMember } from "../../../dashboard/saas/Settings/types";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/organization/member";
const VERSION = 0;

export default async function updateMemberRole(
    userId: string,
    role: "admin" | "member"
): Promise<OrgMember | OrgAdmin> {
    const options: httpNetworking.PUTRequestConfig = {
        timeout: 50000
    };
    const params = {
        userId,
        role
    };

    const response = (await httpNetworking.simplePUTRequest(URL, params, options, VERSION)).data;
    return response;
}
